import { render, staticRenderFns } from "./indexHistorialAnticoncepcionalShow.vue?vue&type=template&id=c76d4a86"
import script from "./indexHistorialAnticoncepcionalShow.vue?vue&type=script&lang=js"
export * from "./indexHistorialAnticoncepcionalShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports